import fetchAx from "@/axios.js";

export default {
  namespaced: true,
  state: {
    raporData: [
      {
        toplamCalismaZamani: 0,
        planliDuruslar: 0,
        plansizDuruslar: 0,
        toplamDurus: 0,
        netCalismaSuresi: 0,
        toplamUretim: 0,
        netUretim: 0,
        planlananUretim: 0,
        kullanilabilirlik: 0,
        kalite: 0,
        performans: 0,
        oee: 0,
        toplam_uretim_ay1: 0,
        toplam_uretim_ay2: 0,
        toplam_uretim_ay3: 0,
        toplam_uretim_ay4: 0,
        toplam_uretim_ay5: 0,
        toplam_uretim_ay6: 0,
        toplam_uretim_ay7: 0,
        toplam_uretim_ay8: 0,
        toplam_uretim_ay9: 0,
        toplam_uretim_ay10: 0,
        toplam_uretim_ay11: 0,
        toplam_uretim_ay12: 0,
        toplam_uretim_toplam: 0,
        kullanilabilirlik_ay1: 0,
        kullanilabilirlik_ay2: 0,
        kullanilabilirlik_ay3: 0,
        kullanilabilirlik_ay4: 0,
        kullanilabilirlik_ay5: 0,
        kullanilabilirlik_ay6: 0,
        kullanilabilirlik_ay7: 0,
        kullanilabilirlik_ay8: 0,
        kullanilabilirlik_ay9: 0,
        kullanilabilirlik_ay10: 0,
        kullanilabilirlik_ay11: 0,
        kullanilabilirlik_ay12: 0,
        kullanilabilirlik_toplam: 0,
        kalite_ay1: 0,
        kalite_ay2: 0,
        kalite_ay3: 0,
        kalite_ay4: 0,
        kalite_ay5: 0,
        kalite_ay6: 0,
        kalite_ay7: 0,
        kalite_ay8: 0,
        kalite_ay9: 0,
        kalite_ay10: 0,
        kalite_ay11: 0,
        kalite_ay12: 0,
        kalite_toplam: 0,
        performans_ay1: 0,
        performans_ay2: 0,
        performans_ay3: 0,
        performans_ay4: 0,
        performans_ay5: 0,
        performans_ay6: 0,
        performans_ay7: 0,
        performans_ay8: 0,
        performans_ay9: 0,
        performans_ay10: 0,
        performans_ay11: 0,
        performans_ay12: 0,
        performans_toplam: 0,
        Hedef_OEE_min_ay1: 0,
        Hedef_OEE_min_ay2: 0,
        Hedef_OEE_min_ay3: 0,
        Hedef_OEE_min_ay4: 0,
        Hedef_OEE_min_ay5: 0,
        Hedef_OEE_min_ay6: 0,
        Hedef_OEE_min_ay7: 0,
        Hedef_OEE_min_ay8: 0,
        Hedef_OEE_min_ay9: 0,
        Hedef_OEE_min_ay10: 0,
        Hedef_OEE_min_ay11: 0,
        Hedef_OEE_min_ay12: 0,
        Hedef_OEE_min_toplam: 0,
        Hedef_OEE_max_ay1: 0,
        Hedef_OEE_max_ay2: 0,
        Hedef_OEE_max_ay3: 0,
        Hedef_OEE_max_ay4: 0,
        Hedef_OEE_max_ay5: 0,
        Hedef_OEE_max_ay6: 0,
        Hedef_OEE_max_ay7: 0,
        Hedef_OEE_max_ay8: 0,
        Hedef_OEE_max_ay9: 0,
        Hedef_OEE_max_ay10: 0,
        Hedef_OEE_max_ay11: 0,
        Hedef_OEE_max_ay12: 0,
        Hedef_OEE_max_toplam: 0,
        OEE_ay1: 0,
        OEE_ay2: 0,
        OEE_ay3: 0,
        OEE_ay4: 0,
        OEE_ay5: 0,
        OEE_ay6: 0,
        OEE_ay7: 0,
        OEE_ay8: 0,
        OEE_ay9: 0,
        OEE_ay10: 0,
        OEE_ay11: 0,
        OEE_ay12: 0,
        OEE_toplam: 0,
        fire_miktar_ay1: 0,
        fire_miktar_ay2: 0,
        fire_miktar_ay3: 0,
        fire_miktar_ay4: 0,
        fire_miktar_ay5: 0,
        fire_miktar_ay6: 0,
        fire_miktar_ay7: 0,
        fire_miktar_ay8: 0,
        fire_miktar_ay9: 0,
        fire_miktar_ay10: 0,
        fire_miktar_ay11: 0,
        fire_miktar_ay12: 0,
        fire_miktar_toplam: 0,
        net_calisma_suresi_ay1: 0,
        net_calisma_suresi_ay2: 0,
        net_calisma_suresi_ay3: 0,
        net_calisma_suresi_ay4: 0,
        net_calisma_suresi_ay5: 0,
        net_calisma_suresi_ay6: 0,
        net_calisma_suresi_ay7: 0,
        net_calisma_suresi_ay8: 0,
        net_calisma_suresi_ay9: 0,
        net_calisma_suresi_ay10: 0,
        net_calisma_suresi_ay11: 0,
        net_calisma_suresi_ay12: 0,
        net_calisma_suresi_toplam: 0,
        net_uretim_ay1: 0,
        net_uretim_ay2: 0,
        net_uretim_ay3: 0,
        net_uretim_ay4: 0,
        net_uretim_ay5: 0,
        net_uretim_ay6: 0,
        net_uretim_ay7: 0,
        net_uretim_ay8: 0,
        net_uretim_ay9: 0,
        net_uretim_ay10: 0,
        net_uretim_ay11: 0,
        net_uretim_ay12: 0,
        net_uretim_toplam: 0,
        planlanan_uretim_ay1: 0,
        planlanan_uretim_ay2: 0,
        planlanan_uretim_ay3: 0,
        planlanan_uretim_ay4: 0,
        planlanan_uretim_ay5: 0,
        planlanan_uretim_ay6: 0,
        planlanan_uretim_ay7: 0,
        planlanan_uretim_ay8: 0,
        planlanan_uretim_ay9: 0,
        planlanan_uretim_ay10: 0,
        planlanan_uretim_ay11: 0,
        planlanan_uretim_ay12: 0,
        planlanan_uretim_toplam: 0,
        planli_durus_suresi_ay1: 0,
        planli_durus_suresi_ay2: 0,
        planli_durus_suresi_ay3: 0,
        planli_durus_suresi_ay4: 0,
        planli_durus_suresi_ay5: 0,
        planli_durus_suresi_ay6: 0,
        planli_durus_suresi_ay7: 0,
        planli_durus_suresi_ay8: 0,
        planli_durus_suresi_ay9: 0,
        planli_durus_suresi_ay10: 0,
        planli_durus_suresi_ay11: 0,
        planli_durus_suresi_ay12: 0,
        planli_durus_suresi_toplam: 0,
        plansiz_durus_suresi_ay1: 0,
        plansiz_durus_suresi_ay2: 0,
        plansiz_durus_suresi_ay3: 0,
        plansiz_durus_suresi_ay4: 0,
        plansiz_durus_suresi_ay5: 0,
        plansiz_durus_suresi_ay6: 0,
        plansiz_durus_suresi_ay7: 0,
        plansiz_durus_suresi_ay8: 0,
        plansiz_durus_suresi_ay9: 0,
        plansiz_durus_suresi_ay10: 0,
        plansiz_durus_suresi_ay11: 0,
        plansiz_durus_suresi_ay12: 0,
        plansiz_durus_suresi_toplam: 0,
        toplam_durus_ay1: 0,
        toplam_durus_ay2: 0,
        toplam_durus_ay3: 0,
        toplam_durus_ay4: 0,
        toplam_durus_ay5: 0,
        toplam_durus_ay6: 0,
        toplam_durus_ay7: 0,
        toplam_durus_ay8: 0,
        toplam_durus_ay9: 0,
        toplam_durus_ay10: 0,
        toplam_durus_ay11: 0,
        toplam_durus_ay12: 0,
        toplam_durus_toplam: 0,
        toplam_sure_ay1: 0,
        toplam_sure_ay2: 0,
        toplam_sure_ay3: 0,
        toplam_sure_ay4: 0,
        toplam_sure_ay5: 0,
        toplam_sure_ay6: 0,
        toplam_sure_ay7: 0,
        toplam_sure_ay8: 0,
        toplam_sure_ay9: 0,
        toplam_sure_ay10: 0,
        toplam_sure_ay11: 0,
        toplam_sure_ay12: 0,
        toplam_sure_toplam: 0,
        fireMiktar: 0,
        planli: [],
        plansiz: [],
      },
    ],
    vardiyaList: [],
  },
  mutations: {
    setRaporData(state, payload) {
      state.raporData = payload;
    },
    setVardiyaList(state, payload) {
      state.vardiyaList = payload;
    },
  },
  getters: {
    getRaporData: (state) => state.raporData,
    getVardiyaListBas(state) {
      return state.vardiyaList.filter((item) => item.TIP === "BAS");
    },
    getVardiyaListBit(state) {
      return state.vardiyaList.filter((item) => item.TIP === "BIT");
    },
  },
  actions: {
    // fetchRaporData({ commit }, payload) {
    //   console.log("payload :>> ", payload);
    //   let kriterler = {
    //     queryKey: "ScadaOEEListele",
    //     metin1: payload.BASTARIH,
    //     metin2: payload.BITTARIH,
    //     metin3: payload.BOLUMNO,
    //     metin4: payload.TEZGAHNO,
    //   };
    //   return new Promise(async (resolve, reject) => {
    //     await fetchAx
    //       .post("v1/Dynamic/GetQueryReplaceData", kriterler)
    //       .then((response) => {
    //         const data = JSON.parse(response.data.data.dataJson);
    //         commit("setRaporData", data[0]);
    //         resolve(data);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //         console.error("Error fetching data:", error);
    //       });
    //   });
    // },
    fetchScadaVardiya({ commit }, payload) {
      let kriterler = {
        queryKey: "ScadaRaporlamaVardiyaSecim",
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            commit("setVardiyaList", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    fetchKullanılabilirlik({ commit }, payload) {
      console.log("payload :>> ", payload);
      let kriterler = {
        queryKey: "OEE_KullanaBilirlik",
        metin1: payload.tezgah,
        metin2: payload.bastarih,
        metin3: payload.endTarih,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            resolve(data[0].ORAN);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    fetchPerformans({ commit }, payload) {
      console.log("payload :>> ", payload);
      let kriterler = {
        queryKey: "OEE_Performans",
        metin1: payload.tezgah,
        metin2: payload.bastarih,
        metin3: payload.endTarih,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            resolve(data[0].PERFORMANS);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    fetchKalite({ commit }, payload) {
      console.log("payload :>> ", payload);
      let kriterler = {
        queryKey: "OEE_Kalite",
        metin1: payload.tezgah,
        metin2: payload.bastarih,
        metin3: payload.endTarih,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            resolve(data[0].KALITE);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    fetchPlanliDuruslar({ commit }, payload) {
      console.log("payload :>> ", payload);
      let kriterler = {
        queryKey: "OEE_Planli_Duruslar",
        metin1: payload.tezgah,
        metin2: payload.bastarih,
        metin3: payload.endTarih,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    fetchPlansizDuruslar({}, payload) {
      let kriterler = {
        queryKey: "OEE_Plansiz_Duruslar",
        metin1: payload.tezgah,
        metin2: payload.bastarih,
        metin3: payload.endTarih,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    fetchOEEAlanlar({}, payload) {
      let kriterler = {
        queryKey: "OEE_Alanlar",
        metin1: payload.tezgah,
        metin2: payload.bastarih,
        metin3: payload.endTarih,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            console.log("data :>> ", data);
            resolve(data[0]);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
    fetchOEEaylar({}, payload) {
      let year = new Date(payload.bastarih).getFullYear();
      let firstDayOfYear = `${year}-01-01`;
      let lastDayOfYear = `${year}-12-31`;
      let kriterler = {
        queryKey: "OEE_YilinAylari_TumDegerler",
        metin1: payload.tezgah,
        metin2: firstDayOfYear,
        metin3: lastDayOfYear,
      };
      return new Promise(async (resolve, reject) => {
        await fetchAx
          .post("v1/Dynamic/GetQueryReplaceData", kriterler)
          .then((response) => {
            const data = JSON.parse(response.data.data.dataJson);
            console.log("data :>> ", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
            console.error("Error fetching data:", error);
          });
      });
    },
  },
};
